import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faClockRotateLeft, faCopy, faEdit, faListOl, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { ProductApi, ProductDataType } from "@/api/ProductsApi";
import { CategoryApi } from "@/api/CategoryApi";
import { formatCant } from "@utils/Cant";

const ProductIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ProductApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Producto no puedo ser eliminado');
    } else {
      showAlert('success', 'El Producto fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Productos"
      backUrl="/user/dashboard"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/product')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "Categorias",
          href: "/user/categories"
        },
        {
          actionTitle: "Codigos De Barra",
          href: "/user/products/generateBarcode"
        },
        {
          actionTitle: "Importar Productos",
          href: "/user/products/import"
        },
        {
          actionTitle: "Administración de Inventarios",
          href: "/user/products/inventory-management"
        },
        {
          actionTitle: "Reportes de Inventario",
          href: "/user/dashboard-inventory"
        }
      ]}
    >
      <ModelIndex<ProductDataType>
        ref={modelRef}
        meiliConfig={{
          index: "products",
          hitsPerPage: 50,
          sort: ["codigo:asc"],
          filter: "temporal != true"
        }}
        mandatoryFilters={[{ temporal: { ne: true } }]}
        fetchAdditionaItems={(searchCriteria: string) => ProductApi.searchByProductByCode(searchCriteria)}
        fetchData={(...args) => ProductApi.fetchAll(...args)}
        relatedFetchData={(...args) => ProductApi.fetchAllByCategory(...args)}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq"
          },
          {
            key: "descripcion",
            filterType: "contains"
          },
          {
            key: "descripcion_fact",
            filterType: "contains"
          },
          {
            key: "categoryId",
            filterType: "eq",
            placeholder: "Categoria",
            options: async () => CategoryApi.optionsList()
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "8", md: "4" },
            { sm: "6", md: "1" },
            { sm: "6", md: "1" }
          ]
        }
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "descripcion_fact"
          },
          {
            key: (data) => formatCant(data.existencias)
          },
          {
            key: (data) => {
              return `${(data.precio1 || data.costo)}`
            },
            highlighted: true
          }
        ]}
        listActions={[
          {
            href: "/user/products/historical-cost/{:id}",
            actionTitle: "Ver Historico de Costos",
            iconProps: { icon: faClockRotateLeft }
          },
          {
            href: "/user/products/movements/{:id}",
            actionTitle: "Movimientos de Inventario de Producto",
            iconProps: { icon: faListOl }
          },
          {
            href: "/user/products/copy/{:id}",
            actionTitle: "Copiar Producto",
            iconProps: { icon: faCopy }
          },
          {
            href: "/user/product/{:id}",
            actionTitle: "Editar Producto",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Producto",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Producto",
              confirmMessage: "¿Seguro que desea eliminar este Producto?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ProductIndex;
